export default "__VITE_ASSET__12a90e72__"